"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Opponent = void 0;
const Block_1 = require("./Block");
class Opponent extends Block_1.Block {
    constructor(app, pkey) {
        super(app);
        this.pkey = pkey;
        this.midscale = 0.5;
        this.endscale = 0.4;
    }
}
exports.Opponent = Opponent;
